import { useNavigate } from 'react-router-dom';

const LyocLinks = ({ gameUI = false }) => {
	const navigate = useNavigate();

	const openLinkInNewTab = (
		e: React.MouseEvent<HTMLButtonElement>,
		url: string
	) => {
		e.preventDefault();
		const newTab = window.open(url, '_blank', 'noopener,noreferrer');
		if (newTab) newTab.opener = null;
	};

	const handleNavigateToCredits = async (e: any) => {
		e.preventDefault();
		navigate('../credit', { replace: true });
	};

	const UIButton = (buttonText: string, buttonLink: string) => {
		if (gameUI) {
			return (
				<button
					className="split-button"
					onClick={(e) => openLinkInNewTab(e, buttonLink)}
				>
					<span className="left-text">{buttonText}</span>
				</button>
			);
		}

		return (
			<button onClick={(e) => openLinkInNewTab(e, buttonLink)}>
				{buttonText}
			</button>
		);
	};

	const UIButtonCredits = () => {
		if (gameUI) {
			return (
				<button
					className="split-button"
					onClick={(e) => {
						handleNavigateToCredits(e);
					}}
				>
					<span className="left-text">✍️ Credits</span>
				</button>
			);
		}

		return (
			<button
				onClick={(e) => {
					handleNavigateToCredits(e);
				}}
			>
				✍️ Credits
			</button>
		);
	};

	const UIButtonCollection = () => {
		return (
			<>
				{UIButton(
					'🎥 Watch The Board Game Tutorial',
					'https://www.youtube.com/watch?v=Ki1DJEGKkzM'
				)}
				{UIButton(
					'📖 Read the Rulebook',
					'https://lastyearofcarbon.com/LYOC-Rulebook_V14_vert.pdf'
				)}
				{UIButton('💰 Buy A Physical Copy!', 'https://lyoc.shop')}
				{UIButton(
					'📸 Follow us on Instagram',
					'https://www.instagram.com/lastyearofcarbon/'
				)}
				{UIButtonCredits()}
			</>
		);
	};

	if (gameUI) {
		return <UIButtonCollection />;
	}

	return (
		<div className="login-form">
			<UIButtonCollection />
		</div>
	);
};

export default LyocLinks;
